import { useState } from 'react'
import {
  DiagnosticCollectionFormValue,
  DiagnosticCollectionSetterFactory
} from '.'

// exported for testing
export function getDiagnosticCollectionInitialState(): DiagnosticCollectionFormValue {
  return {
    enabled: DefaultDiagnosticCollectionValues.enabled,
    logLevel: DefaultDiagnosticCollectionValues.logLevel,
    duration: DefaultDiagnosticCollectionValues.duration
  }
}

export class DefaultDiagnosticCollectionValues {
  static readonly enabled: boolean = false
  static readonly logLevel = 'DEBUG'
  static readonly duration = 0

  static isDefault = (original: DiagnosticCollectionFormValue) => {
    return (
      original.enabled === DefaultDiagnosticCollectionValues.enabled &&
      original.logLevel === DefaultDiagnosticCollectionValues.logLevel &&
      original.duration === DefaultDiagnosticCollectionValues.duration
    )
  }
}

export interface StateManagerProps {
  readonly children: (props: StateManagerChildrenProps) => any
}

export interface StateManagerChildrenProps {
  readonly formValue: DiagnosticCollectionFormValue
  readonly reset: () => void
  readonly formSetter: DiagnosticCollectionSetterFactory
  readonly hasUnsavedChanges: boolean
}

export const hasUnsavedChanges = (
  original: DiagnosticCollectionFormValue,
  current: DiagnosticCollectionFormValue
) => {
  if (
    original.logLevel !== current.logLevel ||
    original.duration !== current.duration
  ) {
    return true
  }
  return false
}

export function DiagnosticCollectionStateManager({
  children
}: StateManagerProps) {
  const [originalFormValue] = useState<DiagnosticCollectionFormValue>(
    getDiagnosticCollectionInitialState()
  )
  const [formValue, setState] = useState<DiagnosticCollectionFormValue>(
    getDiagnosticCollectionInitialState()
  )

  const formSetter: DiagnosticCollectionSetterFactory =
    (key: keyof DiagnosticCollectionFormValue) => (value) =>
      setState({
        ...formValue,
        [key]: value
      })

  const reset = () => setState(getDiagnosticCollectionInitialState())

  return children({
    formValue,
    reset,
    formSetter,
    hasUnsavedChanges:
      !DefaultDiagnosticCollectionValues.isDefault(originalFormValue) ||
      hasUnsavedChanges(originalFormValue, formValue)
  })
}
